"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcContractLifecycle = exports.FieldsetContractLifecycle = void 0;
const FieldsetContractLifecycle_yaml_component_1 = __importDefault(require("./FieldsetContractLifecycle.yaml?component"));
exports.FieldsetContractLifecycle = FieldsetContractLifecycle_yaml_component_1.default;
const UcContractLifecycle_yaml_component_1 = __importDefault(require("./UcContractLifecycle.yaml?component"));
exports.UcContractLifecycle = UcContractLifecycle_yaml_component_1.default;
